import './InlineFolder.7a2c657fcb59cca74b3d64a7f213128b.css';
export default {"inlineFolder":"_inlineFolder_1qbyd_1","label":"_label_1qbyd_1"};